import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-empty',
  standalone: true,
  imports: [],
  template: `
    <div class="flex flex-col items-center justify-center text-center mt-16">
      <div>
        <svg
          width="57"
          height="56"
          viewBox="0 0 57 56"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_814_160)">
            <path
              d="M23.8333 39.6667C32.854 39.6667 40.1667 32.354 40.1667 23.3333C40.1667 14.3127 32.854 7 23.8333 7C14.8127 7 7.5 14.3127 7.5 23.3333C7.5 32.354 14.8127 39.6667 23.8333 39.6667Z"
              stroke="#64748B"
              stroke-width="8"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M49.5 49L35.5 35"
              stroke="#64748B"
              stroke-width="8"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_814_160">
              <rect
                width="56"
                height="56"
                fill="white"
                transform="translate(0.5)"
              />
            </clipPath>
          </defs>
        </svg>
      </div>
      <div class="flex justify-center text-2xl my-2">No Data Found</div>
      <div class="info-2 flex justify-center text-xl my-2">
        {{ emptyStateMessage }}
      </div>
    </div>
  `
})
export class EmptyComponent {
  @Input({ required: true }) emptyStateMessage!: string;}
